






















import { Vue, Component, Prop } from 'vue-property-decorator'
import { date } from 'quasar'
import dateShort from 'src/assets/dateShort'
import PersonAvatar from 'components/account/PersonAvatar.vue'
import MarkdownPreviewer from 'components/MarkdownPreviewer.vue'
import { ForumTopic } from 'src/graphql/types'

@Component({
  components: {
    PersonAvatar,
    MarkdownPreviewer
  }
})
export default class PresenterLayoutActivityDashboardForumTopicItem extends Vue {
  formatDate = date.formatDate
  dateShort = dateShort

  @Prop()
  readonly topic!: ForumTopic

  @Prop()
  readonly to!: string
}
